import axiosInstance from "../axiosInterceptor";

export async function getSubcategoryWisePrice(id) {
  const response = await axiosInstance.get(
    `/admin/homeworkPrice/getSubcategoryWisePrice/${id}`
  );
  const data = response?.data;
  return data;
}
